import { SvgIcon, SvgIconProps } from '@mui/material'

export function MoreAppIcon(props: SvgIconProps) {
  return (
    <SvgIcon role="img" viewBox="0 0 16 16" {...props}>
      <g
        clipPath="url(#a)"
        fillRule="evenodd"
        clipRule="evenodd"
        fill="currentColor"
      >
        <path d="M2 1.833A.167.167 0 0 0 1.833 2v4c0 .092.075.166.167.166h4A.167.167 0 0 0 6.167 6V2A.167.167 0 0 0 6 1.833H2ZM.833 2C.833 1.355 1.356.833 2 .833h4c.644 0 1.167.522 1.167 1.167v4c0 .644-.523 1.166-1.167 1.166H2A1.167 1.167 0 0 1 .833 6V2ZM2 9.833a.167.167 0 0 0-.167.167v4c0 .092.075.166.167.166h4A.167.167 0 0 0 6.167 14v-4A.167.167 0 0 0 6 9.833H2ZM.833 10c0-.645.523-1.167 1.167-1.167h4c.644 0 1.167.522 1.167 1.167v4c0 .644-.523 1.166-1.167 1.166H2A1.167 1.167 0 0 1 .833 14v-4ZM10 1.833A.167.167 0 0 0 9.833 2v4c0 .092.075.166.167.166h4A.167.167 0 0 0 14.167 6V2A.167.167 0 0 0 14 1.833h-4ZM8.833 2c0-.645.523-1.167 1.167-1.167h4c.644 0 1.167.522 1.167 1.167v4c0 .644-.523 1.166-1.167 1.166h-4A1.167 1.167 0 0 1 8.833 6V2Zm0 7.333a.5.5 0 0 1 .5-.5h5.334a.5.5 0 0 1 0 1H9.333a.5.5 0 0 1-.5-.5ZM11.5 12a.5.5 0 0 1 .5-.5h2.667a.5.5 0 0 1 0 1H12a.5.5 0 0 1-.5-.5Zm-2.667 2.667a.5.5 0 0 1 .5-.5h5.334a.5.5 0 1 1 0 1H9.333a.5.5 0 0 1-.5-.5Z" />
      </g>
      <defs>
        <clipPath id="a">
          <path fill="#fff" d="M0 0h16v16H0z" />
        </clipPath>
      </defs>
    </SvgIcon>
  )
}

export default MoreAppIcon
